export default "__VITE_ASSET__70aef112__"